import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { postPokeToUserOwnTractor } from '../../../../api/product/mutations/postPokeToUserOwnTractor';
import { usePatchFlarelaneUserTags } from '../../flarelane/usePatchFlarelaneUserTags';

export const usePostPokeToUserOwnTractor = () => {
  const location = useLocation();
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();
  const queryClient = useQueryClient();

  return useMutation(postPokeToUserOwnTractor, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user_own_tractor_pokes_me_count'] });
      patchFlarelaneUserTags({ lastExecutedPoke: new Date().toISOString() });
    },
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '찔러보기 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
